import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

import CommonService from "../../services/common.service";
import useAutoAddQueryString from "../../Helpers/useAutoAddQueryString";
const AveragePointStats = () => {
  const clubDetails = JSON.parse(localStorage.getItem("club_details"));
  useAutoAddQueryString();
  const [playerAverageStatData, setPlayerAverageStatData] = useState([]);
  const [topManagerData, setTopManagerData] = useState([]);
  const [roundTrades, setRoundTrades] = useState([]);
  const [topPlayerStatsData, setTopPlayerStatsData] = useState([]);
  const getchGetAveragePointStats = () => {
    CommonService.getAveragePointStat().then((res) => {
      if (res.success) {
        setPlayerAverageStatData(res.data);
      }
    });
  };
  const getRoundTrades = () => {
    CommonService.getAverageTotalTradeStat().then((res) => {
      if (res.success) {
        setRoundTrades(res.data);
      }
    });
  };
  const getTopManagerData = () => {
    CommonService.getTopManager().then((res) => {
      if (res.success) {
        setTopManagerData(res.data);
      }
    });
  };
  const getTopPlayerPoints = () => {
    CommonService.getTopPlayerStats().then((res) => {
      if (res.success) {
        setTopPlayerStatsData(res.data);
      }
    });
  };

  useEffect(() => {
    getTopManagerData();
  }, []);

  const [activeTab, setActiveTab] = useState("topManager");
  return (
    <>
      <div className="middle-section">
        <div className="container">
          <div className="innerwhite-section">
            <div className="heading">
              <h2>Round Stats</h2>
            </div>
            <ul className="nav tradetab nav-tabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "topManager" ? "active" : ""
                  }`}
                  id="topManager-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#topManager"
                  type="button"
                  role="tab"
                  aria-controls="topManager"
                  aria-selected="true"
                  onClick={() => {
                    setActiveTab("topManager");
                    getTopManagerData();
                  }}
                >
                  Managers
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "topPlayer" ? "active" : ""
                  }`}
                  id="topPlayer-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#topPlayer"
                  type="button"
                  role="tab"
                  aria-controls="topPlayer"
                  aria-selected="true"
                  onClick={() => {
                    setActiveTab("topPlayer");
                    getTopPlayerPoints();
                  }}
                >
                  Players
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "overall" ? "active" : ""
                  }`}
                  id="overall-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#overall"
                  type="button"
                  role="tab"
                  aria-controls="overall"
                  aria-selected={activeTab === "overall"}
                  onClick={() => {
                    setActiveTab("overall");
                    getchGetAveragePointStats();
                  }}
                >
                  Average Points
                </button>
              </li>
              <li className="nav-item" role="presentation">
                <button
                  className={`nav-link ${
                    activeTab === "round" ? "active" : ""
                  }`}
                  id="round-tab"
                  data-bs-toggle="tab"
                  data-bs-target="#round"
                  type="button"
                  role="tab"
                  aria-controls="round"
                  aria-selected={activeTab === "round"}
                  onClick={() => {
                    setActiveTab("round");
                    getRoundTrades();
                  }}
                >
                  Trades
                </button>
              </li>
            </ul>
            <div className="playercardlist">
              {activeTab === "overall" && (
                <div
                  className={`nav-link ${
                    activeTab === "overall" ? "active" : ""
                  }`}
                  id="overall"
                  role="tabpanel"
                  aria-labelledby="overall-tab"
                >
                  <ul>
                    {playerAverageStatData &&
                      playerAverageStatData
                        .filter((item) => item.average_points !== 0)
                        .map((item, key) => (
                          <li key={key}>
                            <div className="playercardbox">
                              <div className="playercardimg">
                                <figure>
                                  {clubDetails && (
                                    <img
                                      src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                                      alt="img"
                                    />
                                  )}
                                  {!clubDetails && (
                                    <img
                                      src={`/images/club-logo.png`}
                                      alt="img"
                                    />
                                  )}
                                </figure>
                              </div>
                              <h4>
                                <Link> Round {item.round}</Link>
                              </h4>
                              <h6>{item.average_points}</h6>
                            </div>
                          </li>
                        ))}
                  </ul>
                </div>
              )}

              {activeTab === "round" && (
                <div
                  className="tab-pane fade show active"
                  id="round"
                  role="tabpanel"
                  aria-labelledby="round-tab"
                >
                  <ul>
                    {roundTrades &&
                      roundTrades
                        .filter((item) => item.trade_count !== 0)
                        .map((item, key) => (
                          <li key={key}>
                            <div className="playercardbox">
                              <div className="playercardimg">
                                <figure>
                                  {clubDetails && (
                                    <img
                                      src={`${process.env.REACT_APP_UPLOAD_URL}game_logo/${clubDetails?.logo}`}
                                      alt="img"
                                    />
                                  )}
                                  {!clubDetails && (
                                    <img
                                      src={`/images/club-logo.png`}
                                      alt="img"
                                    />
                                  )}
                                </figure>
                              </div>
                              <h4>
                                <Link>Round {item.round}</Link>
                              </h4>

                              <h6>{item.trade_count}</h6>
                            </div>
                          </li>
                        ))}
                  </ul>
                </div>
              )}
              {activeTab === "topManager" && (
                <div
                  className="tab-pane fade show active"
                  id="topManager"
                  role="tabpanel"
                  aria-labelledby="topManager-tab"
                >
                  <ul>
                    {topManagerData &&
                      topManagerData
                        .filter((item) => item.team_points !== 0)
                        .map((item, key) => (
                          <li key={key}>
                            <div className="playercardbox">
                              <div className="playercardimg">
                                <figure>
                                  {item["userdata"]?.image && (
                                    <img
                                      src={`${process.env.REACT_APP_USER_PROFILE}/${item["userdata"]?.image}`}
                                      alt="img"
                                    />
                                  )}
                                  {!item["userdata"]?.image && (
                                    <img
                                      src={`../images/user-img.png`}
                                      alt="img"
                                    />
                                  )}
                                </figure>
                              </div>
                              <h4>
                                <Link> {item["userdata"]?.full_name} </Link>
                              </h4>
                              <h6>{item.team_points}</h6>
                              <span>Round {item?.round}</span>
                            </div>
                          </li>
                        ))}
                  </ul>
                </div>
              )}
              {activeTab === "topPlayer" && (
                <div
                  className="tab-pane fade show active"
                  id="topPlayer"
                  role="tabpanel"
                  aria-labelledby="topPlayer-tab"
                >
                  <ul>
                    {topPlayerStatsData &&
                      topPlayerStatsData
                        .filter((item) => item.sum_fp !== 0)
                        .map(
                          (item, key) =>
                            item["player"] && (
                              <li key={key}>
                                <div className="playercardbox">
                                  <div className="playercardimg">
                                    <figure>
                                      <Link
                                        to={`/player-profile/${item["player"]?.id}`}
                                      >
                                        {item["player"]?.is_avatar === 1 ? (
                                          <img
                                            src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${item["player"]?.image}`}
                                            alt="img"
                                          />
                                        ) : (
                                          <img
                                            src={`${process.env.REACT_APP_UPLOAD_URL}player/${item["player"]?.image}`}
                                            alt="img"
                                          />
                                        )}
                                      </Link>
                                    </figure>
                                  </div>
                                  <h4>
                                    <Link> {item["player"]?.full_name} </Link>
                                  </h4>
                                  <h6>{item.sum_fp}</h6>
                                  <span>Round {item?.round}</span>
                                </div>
                              </li>
                            )
                        )}
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AveragePointStats;
